module.exports = __webpack_public_path__ + "img/m1.c076313a.png";